import * as timeUtils from '../../util/time_utils'

export function isEndBeforeStart(endAtTime, startAtTimeStamp, endAtTimeStamp) {
    if (!startAtTimeStamp) {
        return false
    }

    const endBeforeStart = timeUtils.isEndTimeBeforeStartTime(startAtTimeStamp, endAtTime)
    return endBeforeStart && startAtTimeStamp >= endAtTimeStamp
}


// WEBPACK FOOTER //
// ./src/common/components/time_input.js